import { useEffect } from 'react';
import { LOG_ACTIONS, logAction } from '@namespace/analytics';
import { useThemeComponents } from '@namespace/themes';
import { useMobilePWABanner } from '../../hooks/useMobilePWABanner';
import { DownloadPWABanner } from '../DownloadPWABanner';

export const PWA = () => {
  const { isShowPWABanner, isShowInstructions, onSetInstructions } =
    useMobilePWABanner();

  const { InstructionsPWA = null } = useThemeComponents();

  useEffect(() => {
    const logInstall = () => {
      logAction(LOG_ACTIONS.PWA_INSTALL);
    };

    window.addEventListener('appinstalled', logInstall);

    return () => {
      window.removeEventListener('appinstalled', logInstall);
    };
  }, []);

  if (!InstructionsPWA) {
    return null;
  }

  return (
    <>
      {isShowPWABanner && <DownloadPWABanner />}
      {isShowInstructions && (
        <InstructionsPWA setInstructions={onSetInstructions} />
      )}
    </>
  );
};
